var React = require('react');

function Bars (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Group 14","fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeWidth":"3"},[React.createElement("path",{"data-name":"Line 6","d":"M25.3 1.5H1.5","key":0}),React.createElement("path",{"data-name":"Path 170","d":"M25.3 8.5H1.5","key":1}),React.createElement("path",{"data-name":"Path 171","d":"M25.3 15.5H1.5","key":2})]));
}

Bars.defaultProps = {"viewBox":"0 0 26.8 17"};

module.exports = Bars;

Bars.default = Bars;
